// F-003 (2026-07-08) — single source of truth for the document-category
// options, shared by the New Job Type dialog (create-time) and the Job Config
// General tab (edit-time). Previously the General tab kept its OWN shorter
// list, so a create-time value like "form" or "government_form" had no
// matching <option> and rendered blank ("-- None --"), looking unsaved.
//
// R-99 — Capture is a general high-volume capture platform ("replaces IBM
// Datacap"), not an AP-only tool. AP/procurement buckets come first (most
// common job types), then general buckets for govt/tax/HR/general forms so
// e.g. a CA EDD DE 1545 wage notice has an honest home instead of "other".
//
// documentCategory is a free-form string end to end (Prisma String, no DB
// constraint; API JSON schema is string+maxLength, no enum), so extending
// this list is always safe — no consumer can reject or mis-bucket a new value.
export const DOCUMENT_CATEGORIES = [
  "",
  // AP / procurement
  "invoice",
  "receipt",
  "permit",
  "contract",
  "purchase_order",
  "insurance",
  "pay_application",
  // General document buckets
  "form",
  "government_form",
  "tax_form",
  "hr_form",
  "application",
  "claim",
  "other",
];
